// extracted by mini-css-extract-plugin
module.exports = {"container":"EditBlock_container__2pJcz","inputText":"EditBlock_inputText__2E0SO","buttonContainer":"EditBlock_buttonContainer__8OhYU"};